import { createRouter,createWebHashHistory } from 'vue-router'//createWebHistory
import NotFound from '../components/NotFound.vue'  // 引入404组件
import HomeView from '../pages/HomeView.vue'
import LipeiIndex from '../pages/lipei/IndexView.vue'
import Step1Index from '../pages/lipei/Step1View.vue'
import Step2Index from '../pages/lipei/Step2View.vue'
import Step3Index from '../pages/lipei/Step3View.vue'


const routes = [
  // 其他路由配置
  // 例如：
  {
    path: '/home',
    component: HomeView
  },

  {
    path: '/lipei', // 父路由
    // component: LipeiIndex,
    children: [
      {
        path: 'index', // 子路由，路径会变成 /home/settings
        component: LipeiIndex,
        name: 'LipeiIndex',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step1', // 子路由，路径会变成 /home/settings
        component: Step1Index,
        name: 'Step1Index',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step2', // 子路由，路径会变成 /home/settings
        component: Step2Index,
        name: 'Step2Index',
        meta: { title: '客户退款中心' },
      },
      {
        path: 'step3', // 子路由，路径会变成 /home/settings
        component: Step3Index,
        name: 'Step3Index',
        meta: { title: '客户退款中心' },
      }
    ]
  },
  // {
  //   path: '/lipei',
  //   component: LipeiIndex
  // },
  
  // 404 路由，放在最后
  {
    path: '/:pathMatch(.*)*', // 匹配所有路径
    name: 'NotFound',
    component: NotFound,
    meta: { title: '404 - 页面未找到' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),//createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Default Title';
  next();
});
export default router
